import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import type { Observable } from "rxjs";

import { environment } from "../../../environments/environment";

@Injectable({ providedIn: "root" })
export class PasswordService {
    private http = inject(HttpClient);

    save(newPassword: string, currentPassword: string): Observable<any> {
        return this.http.post(
            environment.apiUrl + "api/account/change-password",
            { currentPassword, newPassword },
        );
    }
}
